import {RouteRecordRaw} from "vue-router";
import AgendaView from "@/agenda/views/AgendaView.vue";
import AgendaAppointmentTypesView from "@/agenda/views/AgendaAppointmentTypesView.vue";
import AgendaFrequentationView from "@/agenda/views/AgendaFrequentationView.vue";
import AgendaHealthJourneyView from "@/agenda/views/AgendaHealthJourneyView.vue";

const agendaRouter: RouteRecordRaw[] = [
    {
        path: '/agenda',
        name: 'agenda',
        component: AgendaView,
        meta: {
            title: 'Agenda'
        }
    },
    {
        path: '/agenda/appointment-types',
        name: 'agenda.appointment-types',
        component: AgendaAppointmentTypesView,
        meta: {
            title: 'Configuration des rendez-vous'
        }
    },
    {
        path: '/agenda/frequentation',
        name: 'agenda.frequentation',
        component: AgendaFrequentationView,
        meta: {
            title: 'Fréquentation'
        }
    },
    {
        // `customerId` in the query pre-selects the patient, for the entries
        // that open this screen from a file rather than from the agenda.
        path: '/agenda/health-journey',
        name: 'agenda.health-journey',
        component: AgendaHealthJourneyView,
        meta: {
            title: 'Parcours officinal de santé'
        }
    }
];

export default agendaRouter;
